import magic from 'libs/magic_numbers';

angular.module('zc.zenclerkS')

  .component('zcsConversionTagChecker', {
    templateUrl: '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.html',
    bindings: {
      project: '<',
      showReturn: '<',
      onComplete: '&'
    },
    controller: zcsConversionTagCheckerController,
    controllerAs: 'vm',
  });

zcsConversionTagCheckerController.$inject = ['$interval', '$rootScope', '$scope', '$translate', '$state', 'Devise', 'MongoConversion', 'ZcsOemService', 'currencies'];
function zcsConversionTagCheckerController($interval, $rootScope, $scope, $translate, $state, Devise, MongoConversion, ZcsOemService, currencies) {
  const vm = this;
  vm.currency = currencies[vm.project.currency];

  // variables
  vm.conversions = [];
  vm.showDetails = !vm.project.conversion_tag_confirmed_at;
  vm.isLoading = false;
  vm.lastConversionAt = null;
  vm.interval = null;
  vm.errors = {
    noConversions: false,
    hasBadConversionIds: false,
    hasBadConversionPrices: false,
    hasBadConversionCouponCodes: false,
    hasNoConversionPrice: false,
    hasNoCouponCode: true
  };

  vm.ZcsOemService = ZcsOemService;
  vm.conversionTagPrefix = ZcsOemService.getConversionTagPrefix();
  vm.host = ZcsOemService.getPublishHostForProject(vm.project);

  // actions
  vm.refresh = refresh;
  vm.complete = complete;
  vm.hasTagErrors = hasTagErrors;
  vm.goToNextStep = goToNextStep;

  vm.$onInit = () => {
    refresh();

    $scope.$on('$destroy', () => {
      stopIntervals();
    });
  };

  function refresh() {
    if(vm.isLoading) return;
    vm.isLoading = true;

    const fetchParams = {
      apikey: vm.project.apikey
    };

    if(vm.lastConversionAt) {
      fetchParams.created_at = {
        $gt: vm.lastConversionAt
      };
    }

    MongoConversion.find(fetchParams, {
      sort: {
        created_at: -1
      },
      limit: 20
    })
      .then(conversions => {
        vm.isLoading = false;
        vm.conversions = vm.conversions.concat(conversions);
        vm.conversions = _.chain(vm.conversions)
          .uniqBy(cv => cv._id)
          .sortBy(cv => -cv.created_at)
          .value();

        _.each(vm.conversions, cv => {
          _.each(cv.items, item => {
            try {
              item.parsedName = decodeURIComponent(item.name);
            } catch (err) {
              item.parsedName = item.name;
            }
          });
        });

        checkConversionErrors();

        if(vm.conversions.length > 0) {
          vm.lastConversionAt = _.sortBy(vm.conversions, cv => -cv.created_at)[0].created_at;
        }
      })
      .finally(() => {
        vm.isLoading = false;

        // loop for new conversions in the background
        if(!vm.interval) {
          vm.interval = $interval(refresh, magic.ZCLITE_CONVERSION_TAG_AUTOCHECK_INTERVAL);
        }
      });
  }

  function checkConversionErrors() {
    vm.errors.noConversions = vm.conversions.length === 0;
    if(vm.errors.noConversions) {
      return;
    }

    // check for the various bad reasons
    _.each(vm.conversions, conversion => {
      conversion.badConversionId = isBadConversionId(conversion);
      conversion.badConversionPrice = isBadConversionPrice(conversion);

      // in case of deemed, it does not matter
      if(vm.project.invoice_calculation_type === 'deemed') {
        conversion.isBadConversionCouponCode = isBadConversionCouponCode(conversion);
      } else if(vm.project.invoice_calculation_type === 'normal') {
        // if the calculation type is normal, there must be at least one coupon code in the conversion
        vm.errors.hasNoCouponCode = isMissingConversionCouponCode(conversion);
      }
    });

    const latestConversion = _.head(vm.conversions);
    const totalConversionPrice = _.sumBy(vm.conversions, 'price');

    vm.errors.hasBadConversionIds = isBadConversionId(latestConversion);
    vm.errors.hasBadConversionPrices = isBadConversionPrice(latestConversion);
    vm.errors.hasNoConversionPrice = totalConversionPrice === 0;
    vm.errors.hasBadConversionCouponCodes = vm.project.invoice_calculation_type === 'deemed' && isBadConversionCouponCode(latestConversion);

    if(!vm.errors.noConversions && !vm.errors.hasBadConversionIds && !vm.errors.hasBadConversionPrices && !vm.errors.hasNoConversionPrice) {
      if(vm.project.invoice_calculation_type === 'deemed') {
        if(!vm.errors.hasBadConversionCouponCodes) {
          complete();
        }
      } else if(vm.project.invoice_calculation_type === 'normal') {
        if(!vm.errors.hasNoCouponCode) {
          complete();
        }
      }
    }
  }

  function hasTagErrors() {
    let hadErrors = false;

    _.each(vm.errors, (v, k) => {
      if(v) {
        hadErrors = true;
      }
    });

    return hadErrors;
  }

  function isBadConversionId(conversion) {
    return !conversion.id || conversion.id === `[${$translate.instant('directives.conversionTagChecker.conversionId')}]`;
  }

  function isBadConversionPrice(conversion) {
    return !conversion.price_raw || conversion.price_raw === `[${$translate.instant('directives.conversionTagChecker.conversionPrice')}]`;
  }

  function isBadConversionCouponCode(conversion) {
    return conversion.coupon_code === `[${$translate.instant('directives.conversionTagChecker.couponCode')}]`;
  }

  function isMissingConversionCouponCode(conversion) {
    return conversion.coupon_code === null ||
       angular.isUndefined(conversion.coupon_code) ||
       conversion.coupon_code === `[${$translate.instant('directives.conversionTagChecker.couponCode')}]`;
  }

  function complete() {
    if(!vm.project.conversion_tag_confirmed_at) {
      vm.onComplete();
      // emiting is required for settings pages
      $rootScope.$broadcast('conversionTagFound');
    }
  }

  function goToNextStep() {
    // no need to get more data (+ without this tests are difficult)
    stopIntervals();
    $state.go('zenclerkS.project.setup.complete');
  }

  function stopIntervals() {
    if(vm.interval) {
      $interval.cancel(vm.interval);
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.js